import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { InfoDto } from '../../../shared/models/info/info-dto';
import { IAccessRights } from '../../../shared/models/info/access-rights';
import { IEntityLimitations } from '../../../shared/models/info/entity-limitations';
import { withCache } from '@ngneat/cashew';
import { IEntityFieldHelp } from '../../../shared/models/info/entity-field-help';

@Injectable({
  providedIn: 'root',
})
export class InfoApiService {
  private http = inject(HttpClient);
  private url = environment.api + 'info';

  public getInfo(): Observable<InfoDto> {
    return this.http.get<InfoDto>(this.url, {
      context: withCache(),
    });
  }

  public getAccessRights(): Observable<IAccessRights> {
    return this.http.get<IAccessRights>(this.url + '/access');
  }

  public getEntityFieldLimitations(): Observable<IEntityLimitations[]> {
    return this.http.get<IEntityLimitations[]>(this.url + '/entityFieldLimitations', {
      context: withCache(),
    });
  }

  public getEntityFieldHelp(): Observable<IEntityFieldHelp[]> {
    return this.http.get<IEntityFieldHelp[]>(this.url + '/entityFieldHelp', {});
  }

  public createEntityFieldHelp(entityFieldHelp: IEntityFieldHelp): Observable<void> {
    return this.http.post<void>(this.url + '/entityFieldHelp', entityFieldHelp);
  }
}
